import React from 'react';
import './aboutus.css';

// Academic Board Members Data
const academicBoardMembers = [
  {
    name: "Dr. Dhanuka Weerasinghe MBBS, ",
    position: "Consultant Eye Surgeon, Visiting LAecturer",
    description: "",
  },
  {
    name: "Dr. Asela Abeydeera",
    position: "Community Ophthalmologist, Visiting Lecturer",
    description: "",
  },
  {
    name: "Dr. C Nupearachchi PhD Physics",
    position: (
      <>
        Senior Lecturer,<br />
        University of Sri Jayewardenepura
      </>
    ),
    description: "",
  },
  {
    name: "Ms. Siranthie Salgado M Ed",
    position: "Lecturer, English, Open University of Sri Lanka",
    description: "",
  },
  {
    name: "Vajira Perera PGD OHS",
    position: "Lecturer, Occupational Health and Safety  ",
    description: "",
   
  },
  {
    name: "Orthop. J U Seekubadu HDOT, BSc, MPhil",
    position: "Snr Orthoptist, Visiting Lecturer",
    description: "",
   
  },
  {
    name: "Pooja Ranasinghe MSc Neuroscience ",
    position: "Lecturer, Sri Jayewardenepura University",
    description: "",
  },
  {
    name: "K Suranga Kumara PGD",
    position: "Lecturer, Marketing / Management",
    description: "",
  },
  {
    name: "Thilina Jayasinghe BSc. (Hon) UOR",
    position: "Lecturer, Biochemistry / Microbiology",
    description: "",
  },
  {
    name: "Naresh Pradhan HDOT, IACLE, F Optom",
    position: "Senior Optometrist, vision Scientist",
    description: "",
  },

  {
    name: "M A Dhammika Deshapriya",
    position: "Senior Optometrist, HDOT",
    description: "",
  },

  {
    name: "Lilendra Perera B.Optom",
    position: "Optometrist",
    description: "",
  },
  {
    name: "N Arul Kumar Dip. Opt.",
    position: "Snr Hospital Optometrist",
    description: "",
  },
  {
    name: "Himidira Bopearachchi BSc IT, UOC",
    position: "Software Engineer, Lecturer, Information Technology",
    description: "",
  },
  {
    name: "K L M Rodrigo Dip. Opt.",
    position: "Hospital Optometrist",
    description: "",
  },
  {
    name: "Nishamani Duruge, chairman",
    position: "Ceylon Eye Care Optometric Association",
    description: "",
  },
  {
    name: "Erandi Siriwardhana",
    position: "Registrar, Ceylon Eye Care Optometric Association",
    description: "",
  },

];


function AcademicBoard() {
  return (
    <div className="academic-board-container">
      <h1 className="academic-board-title">Academic Board</h1>
      <p className="academic-board-description">
   
      </p>
      <div className="academic-board-members">
        {academicBoardMembers.map((member, index) => (
          <div key={index} className="academic-board-member">
            <h2>{member.name}</h2>
            <h3>{member.position}</h3>
            <p>{member.description} <br />
            {member.description2}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default AcademicBoard;
